module.exports = __webpack_public_path__ + "static/img/firstpageProduct-new.c3079ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/firstpageProduct-new.png
// module id = Zpd6
// module chunks = 0